import Vue from 'vue';
import { gsap } from 'gsap';
import Circle from '../classes/Circle';

Vue.component('dynamic-background-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            canvas: null,
            ctx: null,
            amountOfArcs: 4,
            circles: [],
            circleGradients: [
                {
                    stop1: 'rgba(34, 51, 255, 1)',
                    stop2: 'rgba(34, 51, 255, 0)',
                },
                {
                    stop1: 'rgba(0 , 140, 255, 0.5)',
                    stop2: 'rgba(0, 140, 255, 0)',
                },
                {
                    stop1: 'rgba(0 , 140, 255, 1)',
                    stop2: 'rgba(0, 140, 255, 0)',
                },
                {
                    stop1: 'rgba(0 , 140, 255, 0.5)',
                    stop2: 'rgba(0, 140, 255, 0)',
                },
            ],
            window: {
                width: 0,
                height: 0,
            },
            allowAnimation: true,
            isFireFox: false,
            requestAnimationFrameId: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        if (navigator.userAgent.match(/firefox|fxios/i)) {
            this.isFireFox = true;
            return;
        }

        this.setBasics();

        EventBus.$on('window-resize', () => {
            this.resize();
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        setBasics() {
            this.canvas = this.$el.querySelector('canvas');
            this.window = {
                width: window.innerWidth,
                height: window.innerHeight,
            };

            this.canvas.width = this.window.width;
            this.canvas.height = this.window.height;

            this.initBackground();
        },

        initBackground() {
            this.ctx = this.canvas.getContext('2d');

            for (let i = 0; i < this.amountOfArcs; i++) {
                const evenOrOdd = [-1, 1];
                const radiusMultiplier = Math.random() * (0.70833333 - 0.54166667);
                const radius = gsap.utils.clamp(
                    150, // min value (mobile)
                    window.innerWidth * 0.55555556, // max value (based on with)
                    this.window.width * (0.54166667 + radiusMultiplier), // value input (actual wanted size)
                );
                const x = Math.random() * this.window.width;
                const vx = (Math.random() * 1 + 1) * evenOrOdd[Math.floor(Math.random() * evenOrOdd.length)];
                const y = Math.random() * this.window.height;
                const vy = (Math.random() * 1 + 1) * evenOrOdd[Math.floor(Math.random() * evenOrOdd.length)];

                // eslint-disable-next-line no-new
                this.circles.push(new Circle(
                    this.ctx,
                    x,
                    y,
                    vx,
                    vy,
                    radius,
                    this.circleGradients[i],
                    this.window,
                ));
            }

            this.allowAnimation = true;
            this.animate();
        },

        animate() {
            if (!this.allowAnimation) {
                return;
            }

            this.requestAnimationFrameId = requestAnimationFrame(this.animate);
            this.ctx.clearRect(0, 0, this.window.width, this.window.height);

            for (let i = 0; i < this.amountOfArcs; i++) {
                this.circles[i].update();
            }
        },

        resize() {
            if (window.innerWidth < 768) {
                return;
            }

            this.allowAnimation = false;
            cancelAnimationFrame(this.requestAnimationFrameId);
            this.circles = null;
            this.circles = [];
            this.setBasics();
        },
    },
});
